import * as React from 'react'

import type { AllFeatureIds } from 'generated/featureIds.generated'

import { observer } from 'mobx-react'

import { CHECKED_FEATURES } from 'modules/core/lib/Tracking/resources'
import hasFeature from 'modules/core/lib/hasFeature'

import RequestUpgradeModal from 'modules/upsell/components/RequestUpgradeModal'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'

interface Props {
  feature: AllFeatureIds
  onClose: () => void
}

const FeatureModalChecker = ({ feature, children, onClose }: React.PropsWithChildren<Props>) => {
  if (hasFeature(feature)) return <>{children}</>

  return (
    <RequestUpgradeModal
      requestReason={ValidReasons.UpgradeFromLegacy}
      requestSource="marketplace-legacy-apps"
      onClose={onClose}
    />
  )
}

export { CHECKED_FEATURES }

export default observer(FeatureModalChecker)
